/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * CircleInfoIcon - Auto-generated from icon.js
 */
export const CircleInfoIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM7 2.625C7.24199 2.625 7.4375 2.82051 7.4375 3.0625C7.4375 3.30449 7.24199 3.5 7 3.5C6.75801 3.5 6.5625 3.30449 6.5625 3.0625C6.5625 2.82051 6.75801 2.625 7 2.625ZM8.30567 11.375H7.41699H6.54199H5.69434C5.45234 11.375 5.25684 11.1795 5.25684 10.9375C5.25684 10.6955 5.45234 10.5 5.69434 10.5H6.54199V6.09082H5.68066C5.43867 6.09082 5.24316 5.89531 5.24316 5.65332C5.24316 5.41133 5.43867 5.21582 5.68066 5.21582H6.54199H6.97949C7.22148 5.21582 7.41699 5.41133 7.41699 5.65332V10.5H8.30567C8.54766 10.5 8.75684 10.6955 8.75684 10.9375C8.75684 11.1795 8.54766 11.375 8.30567 11.375Z"
			fill="current"
		/>
	</svg>
);

export default CircleInfoIcon;
